var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { injectIntl } from 'react-intl';
import { Form, FormGroup, Label, Input, Button, InputGroupText, InputGroupAddon, InputGroup, FormFeedback } from 'reactstrap';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import FormField from '../../components/ui/FormField/FormField';
import LoginCommand from '../../../commands/authentication/LoginCommand';
import { FormErrorContext } from '../../../FormErrorContext';
import { FormattedMessage } from 'react-intl';
/**
 *
 */
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    /**
     *
     */
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            username: undefined,
            password: undefined,
            submitting: false,
            showPassword: false
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    /**
     *
     * @returns {*}
     */
    Login.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var showPasswordButtonStyle = {
            borderRadius: '0 0.375rem 0.375rem 0',
            transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"
        };
        return (React.createElement(Page, { pageName: "login" },
            React.createElement("div", { className: "container vh-100 align-items-center" },
                React.createElement("div", { className: "row h-75 justify-content-center align-items-center flex-column" },
                    React.createElement("div", { className: "pt-5" },
                        React.createElement("img", { src: "/assets/images/logo-link-bi-white.svg", alt: "Link BI", className: "w-100 my-5" }),
                        React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                            React.createElement(Form, { onSubmit: this.onSubmit },
                                React.createElement("fieldset", { disabled: this.state.submitting },
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col text-white text-center" },
                                                React.createElement(Label, { for: "email", style: { fontSize: "larger" } },
                                                    React.createElement(FormattedMessage, { id: "page.login.field.email" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { name: "email", id: "email", autoFocus: true, onChange: this.onInputChange }))),
                                    React.createElement(FormGroup, null,
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col text-white text-center" },
                                                React.createElement(Label, { for: "password", style: { fontSize: "larger" } },
                                                    React.createElement(FormattedMessage, { id: "page.login.field.password" })))),
                                        React.createElement(FormField, null,
                                            React.createElement(InputGroup, null,
                                                React.createElement(Input, { type: this.state.showPassword ? "text" : "password", name: "password", id: "password", onChange: this.onInputChange, invalid: ((_b = (_a = this.state.errors) === null || _a === void 0 ? void 0 : _a['password']) === null || _b === void 0 ? void 0 : _b.length) > 0 }),
                                                React.createElement(InputGroupAddon, { addonType: 'append' },
                                                    React.createElement(InputGroupText, { className: "showPasswordButton", style: showPasswordButtonStyle },
                                                        React.createElement("span", { onClick: function () {
                                                                _this.setState({ showPassword: !_this.state.showPassword });
                                                            }, className: "fe cursor-pointer " + (this.state.showPassword ? "fe-eye" : "fe-eye-off") }))), (_d = (_c = this.state.errors) === null || _c === void 0 ? void 0 : _c['password']) === null || _d === void 0 ? void 0 :
                                                _d.map(function (e) {
                                                    return (React.createElement(FormFeedback, { className: "", invalid: true },
                                                        React.createElement(FormattedMessage, { id: e })));
                                                }))),
                                        React.createElement("div", { className: "col-auto" },
                                            React.createElement(Link, { to: Routes.FORGOT_PASSWORD.path, className: "form-text small text-center text-white", style: { textDecoration: "underline" } },
                                                React.createElement(FormattedMessage, { id: "page.login.forgotpassword" })))),
                                    React.createElement(Button, { className: "w-100 ml-0 mb-3", color: "dark", type: "submit", style: { fontSize: "larger", fontWeight: "bolder" } },
                                        React.createElement(FormattedMessage, { id: "page.login.login" })),
                                    React.createElement("p", { className: "text-center" },
                                        React.createElement("small", { className: "text-white text-center" },
                                            "Nog geen account? ",
                                            React.createElement(Link, { className: "text-white", style: { textDecoration: "underline" }, to: Routes.CREATE_ACCOUNT.path },
                                                React.createElement(FormattedMessage, { id: "page.login.register" })),
                                            "."))))))))));
    };
    /**
     *
     * @param e
     */
    Login.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };
    /**
     *
     * @param e
     */
    Login.prototype.onSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        if (this.state.submitting) {
            return;
        }
        this.setState({ errors: null, submitting: true });
        var intl = this.props.intl;
        var command = new LoginCommand();
        command.execute(this.state.email, this.state.password, intl).then(function () {
            _this.setState({ errors: [], submitting: false });
        }).catch(this.onError);
    };
    /**
     *
     * @param error
     */
    Login.prototype.onError = function (error) {
        var _a;
        var errors = (_a = error.error.response) === null || _a === void 0 ? void 0 : _a.body.errors;
        this.setState({ errors: errors, submitting: false });
    };
    return Login;
}(React.Component));
Login.contextType = ApplicationContext;
export default injectIntl(Login);
